var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'shop-manager-list',
  created () {
    utils.backClear()
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      shopName: '',
      searchCallbackFlag: false
    }
  },
  /** 画面遷移時 **/
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    shopManagers () {
      return this.$store.getters.shopManagers
    },
    nextPage () {
      return this.$store.getters.shopManagerListNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    currentPage () {
      return this.$store.getters.shopManagerListCurrentPage
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      var url = null
      if (readMore) {
        url = this.$store.getters.shopManagerListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function (){
        self.searchCallbackFlag = true
      }
      var data = { 'shop_name': this.shopName }
      if (readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }
      this.$store.dispatch('SHOP_MANAGER_LIST_SEARCH', {url: url, data: data, callback: callback})
    },
    half: function () {
      this.shopName = utils.emHalf(this.shopName)
    },
    goShopManagerEdit: function (shopId) {
      this.$router.push({ path: '/shop_managers/' + shopId + '/edit'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-manager-list.js